module.exports = __webpack_public_path__ + "img/social-yt.6d424068.svg";